import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatTabLink, MatTabNav, MatTabNavPanel} from "@angular/material/tabs";
import {MatTooltip} from "@angular/material/tooltip";
import {NavigationEnd, Router, RouterLink} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {filter, map} from "rxjs";
import {BreakpointsDirective} from "../../../services/directives/breakpoints.directive";
import {LayoutService, ScreenSize} from "../../../services/layout/layout.service";

@Component({
    selector: "app-navigation-tabs",
    imports: [
        BreakpointsDirective,
        MatIcon,
        MatTabLink,
        MatTabNav,
        MatTabNavPanel,
        TranslatePipe,
        MatTooltip,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        RouterLink,
    ],
    templateUrl: "./navigation-tabs.component.html",
    styleUrl: "./navigation-tabs.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationTabsComponent {
    protected readonly ScreenSize = ScreenSize;

    protected readonly layoutService = inject(LayoutService);
    private readonly router = inject(Router);

    protected readonly selectedIndex = toSignal(this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => Math.max(0, this.tabs.findIndex(tab => {
                const id = window.location.pathname.split("/")[1];
                return id === tab.id || tab.subTabs?.some(t => t.id === id) === true;
            }))),
        ),
    );

    protected readonly selectedSubIndex = toSignal(this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => (this.tabs[this.selectedIndex() ?? 0].subTabs ?? []).findIndex(t => t.id === window.location.pathname.split("/")[1])),
            filter(i => i >= 0),
        ),
        {initialValue: 0},
    );

    protected readonly tabs = [
        {
            id: "./",
            icon: "home",
            label: "Home",
        },
        {
            id: "meal-plan-models",
            icon: "widgets",
            translationKey: "meal-plan-model.list.title",
        },
        {
            id: "menu-planning",
            subTabs: [
                {
                    id: "menu-planning",
                    icon: "description",
                    translationKey: "menu-planning.list.title",
                },
                {
                    id: "menu-templates",
                    icon: "edit_document",
                    translationKey: "menu-template.list.title",
                },
            ],
        },
        {
            id: "rough-planning",
            icon: "assignment",
            translationKey: "rough-planning.list.title",
        },
        {
            id: "settings",
            icon: "settings",
            translationKey: "settings.title",
        },
    ];
}
